var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddJobs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "14 15 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    d: "M27.75 17.667h7.303V35H14V17.667h7.303A3.267 3.267 0 0 1 24.526 15a3.267 3.267 0 0 1 3.224 2.667zm-3.224-1.334c-.888 0-1.612.567-1.875 1.334h3.75c-.263-.8-.987-1.334-1.875-1.334zM33.736 19h-18.42v8.5h18.42V19zm-18.42 14.667h18.42v-4.834h-18.42v4.834zm9.21-7.334a.894.894 0 0 1-.888-.9c0-.497.398-.9.888-.9s.888.403.888.9-.397.9-.888.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddJobs);
export default __webpack_public_path__ + "static/media/add-jobs.266723797400647b250c937be3eb1bf2.svg";
export { ForwardRef as ReactComponent };